import React from "react";
import { Building2 } from "lucide-react";
import { Button } from "../components/ui/button";

const LoginPage = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="login-page">
      {/* Left Panel - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 p-12 flex-col justify-between">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-white font-['Manrope']">PropertyCRM</span>
          </div>
        </div>
        
        <div className="space-y-6">
          <h1 className="text-4xl font-bold text-white font-['Manrope'] leading-tight">
            AI-First Lead Management<br />for Real Estate
          </h1>
          <p className="text-lg text-slate-400 leading-relaxed">
            Transform your sales process with intelligent lead scoring, 
            next-best-action recommendations, and an AI sales copilot.
          </p>
          <div className="grid grid-cols-2 gap-4 pt-4">
            <div className="bg-white/5 rounded-xl p-4">
              <p className="text-3xl font-bold text-amber-500 font-['Manrope']">40%</p>
              <p className="text-sm text-slate-400">Faster Lead Response</p>
            </div>
            <div className="bg-white/5 rounded-xl p-4">
              <p className="text-3xl font-bold text-amber-500 font-['Manrope']">2.5x</p>
              <p className="text-sm text-slate-400">Conversion Improvement</p>
            </div>
          </div>
        </div>

        <div className="text-slate-500 text-sm">
          © 2026 PropertyCRM. Built for Indian Real Estate.
        </div>
      </div>

      {/* Right Panel - Login */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md space-y-8">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-3 justify-center mb-8">
            <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-slate-900 font-['Manrope']">PropertyCRM</span>
          </div>

          <div className="text-center">
            <h2 className="text-3xl font-bold text-slate-900 font-['Manrope']">Welcome back</h2>
            <p className="mt-2 text-slate-600">Sign in to access your CRM dashboard</p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-6">
            <Button
              data-testid="google-login-btn"
              onClick={handleGoogleLogin}
              className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-medium rounded-xl flex items-center justify-center gap-3 transition-all duration-200 hover:shadow-lg"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </Button>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-slate-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-slate-500">Secure authentication</span>
              </div>
            </div>

            <div className="text-center text-sm text-slate-500">
              <p>By signing in, you agree to our</p>
              <p className="mt-1">
                <a href="#" className="text-slate-900 hover:underline">Terms of Service</a>
                {" & "}
                <a href="#" className="text-slate-900 hover:underline">Privacy Policy</a>
              </p>
            </div>
          </div>

          <div className="text-center text-sm text-slate-500">
            <p>Need help? Contact <a href="mailto:support@propertycrm.in" className="text-amber-600 hover:underline">support@propertycrm.in</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
